// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { API_BASE_URL } from "api/axiosConfig";
// import SEO from "components/SEO";

// const ResetPassword = () => {
//   const navigate = useNavigate();

//   const [step, setStep] = useState(1); // 1=email, 2=otp, 3=new password
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState("");
//   const [resetToken, setResetToken] = useState("");

//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");

//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");
//   const [error, setError] = useState("");

//   const resetStatus = () => {
//     setError("");
//     setMessage("");
//   };

//   const sendOtp = async (e) => {
//     e.preventDefault();

//     resetStatus();
//     setLoading(true);
//     setOtp("");
//     setResetToken("");
//     setNewPassword("");
//     setConfirmPassword("");

//     try {
//       await axios.post(`${API_BASE_URL}/api/auth/reset-password/send-otp`, {
//         email: email.trim(),
//       });

//       setMessage("OTP sent to your email.");
//       setStep(2);
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//           err.message ||
//           "Failed to send OTP"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const verifyOtp = async (e) => {
//     e.preventDefault();

//     resetStatus();
//     setLoading(true);

//     try {
//       const res = await axios.post(
//         `${API_BASE_URL}/api/auth/reset-password/verify-otp`,
//         {
//           email: email.trim(),
//           otp: otp.trim(),
//         }
//       );

//       const tokenFromApi = res.data?.resetToken;

//       if (!tokenFromApi) {
//         setError("Reset token missing from server response. Please resend OTP.");
//         return;
//       }

//       setResetToken(tokenFromApi);
//       setMessage("OTP verified. Set your new password.");
//       setStep(3);
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//           err.message ||
//           "Invalid OTP"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const changePassword = async (e) => {
//     e.preventDefault();

//     resetStatus();

//     if (!email.trim()) {
//       setError("Email is required.");
//       return;
//     }

//     if (!resetToken) {
//       setError("Reset token missing. Please verify OTP again.");
//       setStep(2);
//       return;
//     }

//     if (newPassword !== confirmPassword) {
//       setError("Passwords do not match.");
//       return;
//     }

//     if (newPassword.length < 8) {
//       setError("Password must be at least 8 characters long.");
//       return;
//     }

//     setLoading(true);

//     try {
//       await axios.post(`${API_BASE_URL}/api/auth/reset-password/change`, {
//         email: email.trim(),
//         resetToken,
//         newPassword,
//       });

//       setMessage("Password updated successfully. Please login.");

//       setTimeout(() => {
//         navigate("/login", { replace: true });
//       }, 1200);
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//           err.message ||
//           "Password update failed"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resendOtp = async () => {
//     resetStatus();
//     setLoading(true);
//     setOtp("");
//     setResetToken("");

//     try {
//       await axios.post(`${API_BASE_URL}/api/auth/reset-password/send-otp`, {
//         email: email.trim(),
//       });

//       setMessage("OTP resent.");
//       setStep(2);
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//           err.message ||
//           "Failed to resend OTP"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const goBackToEmail = () => {
//     setStep(1);
//     setOtp("");
//     setResetToken("");
//     setNewPassword("");
//     setConfirmPassword("");
//     resetStatus();
//   };

//   return (
//     <>
//     <SEO
//   title="Reset Password - TestimonialsHub"
//   description="Reset your TestimonialsHub account password securely and regain access to your testimonial dashboard and customer reviews."
//   keywords="reset password testimonial software, account recovery, testimonialshub password reset"
//   path="/reset-password"
// />

//     <div className="flex min-h-screen bg-gradient-to-br from-purple-400 via-pink-400 to-orange-300 items-center justify-center p-6 font-sans">
//       <div className="w-full max-w-lg bg-gray-100 rounded-2xl shadow-2xl px-10 py-10 flex flex-col justify-center">
//         <h2 className="text-3xl font-bold text-gray-800 mb-3 text-center">
//           Reset Password
//         </h2>

//         <p className="text-base text-gray-500 mb-8 text-center">
//           {step === 1 && "Enter your email to receive an OTP"}
//           {step === 2 && "Enter the OTP sent to your email"}
//           {step === 3 && "Set your new password"}
//         </p>

//         {step === 1 && (
//           <form onSubmit={sendOtp} className="space-y-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Email Address
//               </label>
//               <input
//                 type="email"
//                 placeholder="you@example.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//                 className="w-full h-12 px-4 border border-gray-300 rounded-xl text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//               />
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full h-12 bg-blue-600 text-white text-base font-semibold rounded-xl hover:bg-blue-700 transition shadow-lg disabled:opacity-60"
//             >
//               {loading ? "Sending OTP..." : "Send OTP"}
//             </button>
//           </form>
//         )}

//         {step === 2 && (
//           <form onSubmit={verifyOtp} className="space-y-6">
//             <div className="text-sm text-gray-600">
//               OTP sent to: <strong>{email}</strong>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 OTP
//               </label>
//               <input
//                 type="text"
//                 placeholder="Enter OTP"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//                 required
//                 className="w-full h-12 px-4 border border-gray-300 rounded-xl text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//               />
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full h-12 bg-blue-600 text-white text-base font-semibold rounded-xl hover:bg-blue-700 transition shadow-lg disabled:opacity-60"
//             >
//               {loading ? "Verifying..." : "Verify OTP"}
//             </button>

//             <button
//               type="button"
//               onClick={resendOtp}
//               disabled={loading}
//               className="w-full h-12 border border-gray-300 rounded-xl bg-white hover:bg-gray-50 transition shadow-sm disabled:opacity-60"
//             >
//               Resend OTP
//             </button>

//             <button
//               type="button"
//               onClick={goBackToEmail}
//               className="w-full text-sm text-blue-600 hover:underline"
//             >
//               Change email
//             </button>
//           </form>
//         )}

//         {step === 3 && (
//           <form onSubmit={changePassword} className="space-y-6">
//             <div className="text-sm text-gray-600">
//               Updating password for: <strong>{email}</strong>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 New Password
//               </label>
//               <input
//                 type="password"
//                 placeholder="New Password"
//                 value={newPassword}
//                 onChange={(e) => setNewPassword(e.target.value)}
//                 required
//                 className="w-full h-12 px-4 border border-gray-300 rounded-xl text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Confirm Password
//               </label>
//               <input
//                 type="password"
//                 placeholder="Confirm Password"
//                 value={confirmPassword}
//                 onChange={(e) => setConfirmPassword(e.target.value)}
//                 required
//                 className="w-full h-12 px-4 border border-gray-300 rounded-xl text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//               />
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full h-12 bg-blue-600 text-white text-base font-semibold rounded-xl hover:bg-blue-700 transition shadow-lg disabled:opacity-60"
//             >
//               {loading ? "Updating..." : "Update Password"}
//             </button>

//             <button
//               type="button"
//               onClick={() => {
//                 setStep(2);
//                 setResetToken("");
//                 setNewPassword("");
//                 setConfirmPassword("");
//                 resetStatus();
//               }}
//               className="w-full text-sm text-blue-600 hover:underline"
//             >
//               Verify OTP again
//             </button>
//           </form>
//         )}

//         {message && (
//           <p className="text-center text-sm mt-4 text-green-600">
//             {message}
//           </p>
//         )}

//         {error && (
//           <p className="text-center text-sm mt-4 text-red-600">
//             {error}
//           </p>
//         )}

//         <p className="text-sm text-center text-gray-600 mt-6">
//           Remembered your password?{" "}
//           <Link
//             to="/login"
//             className="text-blue-600 font-medium hover:underline"
//           >
//             Back to Login
//           </Link>
//         </p>
//       </div>
//     </div>
//     </>
//   );
// };

// export default ResetPassword;
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "api/axiosConfig";
import SEO from "components/SEO";

const ResetPassword = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1); // 1=email, 2=otp, 3=new password
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [resetToken, setResetToken] = useState("");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const resetStatus = () => {
    setError("");
    setMessage("");
  };

  const sendOtp = async (e) => {
    e.preventDefault();

    resetStatus();
    setLoading(true);
    setOtp("");
    setResetToken("");
    setNewPassword("");
    setConfirmPassword("");

    try {
      await axios.post(`${API_BASE_URL}/api/auth/reset-password/send-otp`, {
        email: email.trim(),
      });

      setMessage("OTP sent to your email.");
      setStep(2);
    } catch (err) {
      setError(
        err.response?.data?.message || err.message || "Failed to send OTP"
      );
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();

    resetStatus();
    setLoading(true);

    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/auth/reset-password/verify-otp`,
        {
          email: email.trim(),
          otp: otp.trim(),
        }
      );

      const tokenFromApi = res.data?.resetToken;

      if (!tokenFromApi) {
        setError("Reset token missing from server response. Please resend OTP.");
        return;
      }

      setResetToken(tokenFromApi);
      setMessage("OTP verified. Set your new password.");
      setStep(3);
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  const changePassword = async (e) => {
    e.preventDefault();

    resetStatus();

    if (!email.trim()) {
      setError("Email is required.");
      return;
    }

    if (!resetToken) {
      setError("Reset token missing. Please verify OTP again.");
      setStep(2);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API_BASE_URL}/api/auth/reset-password/change`, {
        email: email.trim(),
        resetToken,
        newPassword,
      });

      setMessage("Password updated successfully. Please login.");

      setTimeout(() => {
        navigate("/login", { replace: true });
      }, 1200);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          "Password update failed"
      );
    } finally {
      setLoading(false);
    }
  };

  const resendOtp = async () => {
    resetStatus();
    setLoading(true);
    setOtp("");
    setResetToken("");

    try {
      await axios.post(`${API_BASE_URL}/api/auth/reset-password/send-otp`, {
        email: email.trim(),
      });

      setMessage("OTP resent.");
      setStep(2);
    } catch (err) {
      setError(
        err.response?.data?.message || err.message || "Failed to resend OTP"
      );
    } finally {
      setLoading(false);
    }
  };

  const goBackToEmail = () => {
    setStep(1);
    setOtp("");
    setResetToken("");
    setNewPassword("");
    setConfirmPassword("");
    resetStatus();
  };

  const getSubtitle = () => {
    if (step === 1) return "Enter your email to receive a secure OTP";
    if (step === 2) return "Enter the OTP sent to your email";
    return "Create a strong new password";
  };

  return (
    <>
      <SEO
        title="Reset Password - TestimonialsHub"
        description="Reset your TestimonialsHub account password securely and regain access to your testimonial dashboard and customer reviews."
        keywords="reset password testimonial software, account recovery, testimonialshub password reset"
        path="/reset-password"
      />

      <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-pink-50 via-white to-orange-50 px-6 py-8 font-sans">
        <div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-pink-300/40 blur-3xl" />
        <div className="absolute right-0 top-20 h-96 w-96 rounded-full bg-purple-300/30 blur-3xl" />
        <div className="absolute bottom-0 right-20 h-96 w-96 rounded-full bg-orange-300/40 blur-3xl" />

        <div className="relative z-10 mx-auto mb-10 flex max-w-6xl items-center justify-between rounded-full border border-white/70 bg-white/85 px-6 py-4 shadow-xl shadow-pink-200/30 backdrop-blur-md">
          <Link
            to="/"
            className="text-2xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500"
          >
            TestimonialsHub
          </Link>

          <div className="hidden items-center gap-8 text-sm font-semibold text-gray-600 md:flex">
            <Link to="/" className="hover:text-pink-500 transition">
              Product
            </Link>
            <Link to="/#features" className="hover:text-pink-500 transition">
              Features
            </Link>
            <Link to="/pricing" className="hover:text-pink-500 transition">
              Pricing
            </Link>
            <Link to="/resources" className="hover:text-pink-500 transition">
              Resources
            </Link>
          </div>

          <Link
            to="/login"
            className="rounded-full bg-gradient-to-r from-pink-500 to-orange-400 px-5 py-2.5 text-sm font-bold text-white shadow-lg shadow-pink-300/50 transition hover:scale-105"
          >
            Sign In
          </Link>
        </div>

        <div className="relative z-10 mx-auto grid min-h-[calc(100vh-140px)] max-w-6xl items-center gap-10 lg:grid-cols-2">
          <div className="hidden lg:block">
  <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-white bg-white/80 px-4 py-2 text-sm font-semibold text-gray-700 shadow-lg">
    <span className="h-2.5 w-2.5 rounded-full bg-purple-500" />
    Testimonials built for modern brands
  </div>

  <h1 className="max-w-xl text-6xl font-black leading-tight tracking-tight text-gray-900">
    Collect, manage, and showcase{" "}
    <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500">
      customer testimonials.
    </span>
  </h1>

  <p className="mt-6 max-w-lg text-lg leading-8 text-gray-600">
    Turn happy customer feedback into beautiful social proof. Manage video
    reviews, text testimonials, wall embeds, and portfolio pages from one
    powerful dashboard.
  </p>

  <div className="mt-10 space-y-4">
    <div className="flex items-center gap-4">
      <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 to-orange-400 text-white shadow-lg">
        1
      </div>
      <p className="text-base font-semibold text-gray-700">
        Collect video and text testimonials from customers
      </p>
    </div>

    <div className="flex items-center gap-4">
      <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 to-orange-400 text-white shadow-lg">
        2
      </div>
      <p className="text-base font-semibold text-gray-700">
        Display reviews using beautiful website widgets
      </p>
    </div>

    <div className="flex items-center gap-4">
      <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 to-orange-400 text-white shadow-lg">
        3
      </div>
      <p className="text-base font-semibold text-gray-700">
        Build trust and increase conversions with social proof
      </p>
    </div>
  </div>
</div>

          <div className="mx-auto w-full max-w-lg">
            <div className="relative rounded-[2rem] border border-white/80 bg-white/90 p-3 shadow-2xl shadow-pink-200/50 backdrop-blur-xl">
              <div className="absolute -right-5 -top-5 hidden rounded-2xl bg-gradient-to-br from-pink-500 via-purple-500 to-orange-400 p-4 text-white shadow-xl md:block">
                🔐
              </div>

              <div className="rounded-[1.5rem] bg-gradient-to-br from-white via-pink-50/70 to-orange-50/80 px-8 py-10 sm:px-10">
                <div className="mb-8 text-center">
                  <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 via-purple-500 to-orange-400 text-2xl text-white shadow-lg shadow-pink-300/50">
                    🔑
                  </div>

                  <h2 className="text-4xl font-black tracking-tight text-gray-900">
                    Reset Password
                  </h2>

                  <p className="mt-3 text-base text-gray-500">
                    {getSubtitle()}
                  </p>

                  <div className="mt-6 flex items-center justify-center gap-3">
                    {[1, 2, 3].map((item) => (
                      <div
                        key={item}
                        className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-extrabold transition ${
                          step >= item
                            ? "bg-gradient-to-r from-pink-500 to-orange-400 text-white shadow-md shadow-pink-300/50"
                            : "bg-white text-gray-400 border border-gray-200"
                        }`}
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                </div>

                {step === 1 && (
                  <form onSubmit={sendOtp} className="space-y-6">
                    <div>
                      <label className="mb-2 block text-sm font-bold text-gray-700">
                        Email Address
                      </label>

                      <div className="relative">
                        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-pink-500">
                          ✉
                        </span>

                        <input
                          type="email"
                          placeholder="you@example.com"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          className="h-12 w-full rounded-2xl border border-pink-100 bg-white px-12 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-pink-400 focus:ring-4 focus:ring-pink-200/60"
                        />
                      </div>
                    </div>

                    <button
                      type="submit"
                      disabled={loading}
                      className="group relative h-14 w-full overflow-hidden rounded-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-orange-400 text-base font-extrabold text-white shadow-xl shadow-pink-300/50 transition hover:scale-[1.02] disabled:cursor-not-allowed disabled:opacity-60"
                    >
                      <span className="relative z-10">
                        {loading ? "Sending OTP..." : "Send OTP"}
                      </span>
                      <span className="absolute inset-0 bg-gradient-to-r from-orange-400 via-pink-500 to-purple-500 opacity-0 transition group-hover:opacity-100" />
                    </button>
                  </form>
                )}

                {step === 2 && (
                  <form onSubmit={verifyOtp} className="space-y-6">
                    <div className="rounded-2xl border border-pink-100 bg-white px-4 py-3 text-sm text-gray-600 shadow-sm">
                      OTP sent to:{" "}
                      <strong className="text-gray-900">{email}</strong>
                    </div>

                    <div>
                      <label className="mb-2 block text-sm font-bold text-gray-700">
                        OTP
                      </label>

                      <div className="relative">
                        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-500">
                          #
                        </span>

                        <input
                          type="text"
                          placeholder="Enter OTP"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          required
                          className="h-12 w-full rounded-2xl border border-orange-100 bg-white px-12 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-orange-400 focus:ring-4 focus:ring-orange-200/60"
                        />
                      </div>
                    </div>

                    <button
                      type="submit"
                      disabled={loading}
                      className="group relative h-14 w-full overflow-hidden rounded-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-orange-400 text-base font-extrabold text-white shadow-xl shadow-pink-300/50 transition hover:scale-[1.02] disabled:cursor-not-allowed disabled:opacity-60"
                    >
                      <span className="relative z-10">
                        {loading ? "Verifying..." : "Verify OTP"}
                      </span>
                      <span className="absolute inset-0 bg-gradient-to-r from-orange-400 via-pink-500 to-purple-500 opacity-0 transition group-hover:opacity-100" />
                    </button>

                    <button
                      type="button"
                      onClick={resendOtp}
                      disabled={loading}
                      className="h-12 w-full rounded-2xl border border-pink-200 bg-white text-sm font-bold text-gray-700 shadow-sm transition hover:border-pink-400 hover:text-pink-600 disabled:opacity-60"
                    >
                      Resend OTP
                    </button>

                    <button
                      type="button"
                      onClick={goBackToEmail}
                      className="w-full text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
                    >
                      Change email
                    </button>
                  </form>
                )}

                {step === 3 && (
                  <form onSubmit={changePassword} className="space-y-6">
                    <div className="rounded-2xl border border-pink-100 bg-white px-4 py-3 text-sm text-gray-600 shadow-sm">
                      Updating password for:{" "}
                      <strong className="text-gray-900">{email}</strong>
                    </div>

                    <div>
                      <label className="mb-2 block text-sm font-bold text-gray-700">
                        New Password
                      </label>

                      <input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        className="h-12 w-full rounded-2xl border border-pink-100 bg-white px-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-pink-400 focus:ring-4 focus:ring-pink-200/60"
                      />
                    </div>

                    <div>
                      <label className="mb-2 block text-sm font-bold text-gray-700">
                        Confirm Password
                      </label>

                      <input
                        type="password"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        className="h-12 w-full rounded-2xl border border-orange-100 bg-white px-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-orange-400 focus:ring-4 focus:ring-orange-200/60"
                      />
                    </div>

                    <button
                      type="submit"
                      disabled={loading}
                      className="group relative h-14 w-full overflow-hidden rounded-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-orange-400 text-base font-extrabold text-white shadow-xl shadow-pink-300/50 transition hover:scale-[1.02] disabled:cursor-not-allowed disabled:opacity-60"
                    >
                      <span className="relative z-10">
                        {loading ? "Updating..." : "Update Password"}
                      </span>
                      <span className="absolute inset-0 bg-gradient-to-r from-orange-400 via-pink-500 to-purple-500 opacity-0 transition group-hover:opacity-100" />
                    </button>

                    <button
                      type="button"
                      onClick={() => {
                        setStep(2);
                        setResetToken("");
                        setNewPassword("");
                        setConfirmPassword("");
                        resetStatus();
                      }}
                      className="w-full text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
                    >
                      Verify OTP again
                    </button>
                  </form>
                )}

                {message && (
                  <div className="mt-5 rounded-2xl border border-green-200 bg-green-50 px-4 py-3 text-center text-sm font-medium text-green-700">
                    {message}
                  </div>
                )}

                {error && (
                  <div className="mt-5 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-center text-sm font-medium text-red-600">
                    {error}
                  </div>
                )}

                <p className="mt-6 text-center text-sm text-gray-600">
                  Remembered your password?{" "}
                  <Link
                    to="/login"
                    className="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
                  >
                    Back to Login
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;